export default function MovementSourcesTable({ movementSourceAttribution }) {
  if (!movementSourceAttribution || movementSourceAttribution.length === 0) {
    return null
  }

  // Sort the movementSourceAttribution array by count in descending order
  const sortedData = [...movementSourceAttribution].sort((a, b) => b.count - a.count)

  const entityNames = {
    'Campaign': 'Campaign',
    'Flow': 'Page'
  }

  return (
    <div className='box flex column margin-top double' id='sources'>
      <h1 className='no-margin-top'>Traffic Sources (Movement)</h1>
      <table className="flat-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Visits</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td>{entityNames[item.entity] || '-'}</td>
              <td><a target="_blank" href={item.link}>{item.name}</a></td>
              <td className="count-cell">{item.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}